<app-toast [toastModel]="toastViewModel" *ngIf="isTranslateToaster"></app-toast>
<div class="row" >
  <div class="col-lg-12 position-relative">

    <mat-tab-group (selectedTabChange)="tabMenuChanged($event)">
      <mat-tab label="Change Details">
        <ng-template mat-tab-label>
          <div>
            Change Details
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab label="RIG" *ngIf="checkRoutePermissionWithUrl('/regulatory-insights-generator')">
        <ng-template mat-tab-label>
          <div matTooltip="Regulatory Insights Generator">
            RIG
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab label="MAPS" *ngIf="checkRoutePermissionWithName('MAPS')">
        <ng-template mat-tab-label>
          <div matTooltip="Mapping AI for Policy and Standards">
            MAPS
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
    
    <div class="action_buttons" *ngIf="!isExpendedIconShow">
      <button class="fa fa-times pull-right" [mat-dialog-close]="" style="cursor: pointer;background: none;border:none"
        aria-hidden="true"></button>
      <a href="/change-detail?id={{currentRegulationId}}&detailType=1&libId={{regulationLibraryId}}" target="_blank">
        <span class="fa fa-external-link pull-right external" title="Open in New Window"></span>
      </a>
    </div>

  </div>
</div>
<app-progress-bar [isLoading]="isRegLoading"></app-progress-bar>


<div class="row" *ngIf="isChangeDetails">
  <div [ngClass]="!isShowComparison ? 'col-lg-12' : 'col-lg-6 pr-0'">
    <!-- Details & action -->
    <div class="row">
      <div class="col-md-9 pr-0">
        <div class="card">
          <div class="card-header text-header inc-f">
            Details
          </div>
          <div class="card-body card-height">
            <div class="row">
              <div class="col-lg-2">
                <div class="form-group">
                  <div class="left inline label-heading control-label mb-1 fw">
                    Change ID
                  </div>
                  <div class="input-group">
                    <input type="text" id="SerachText" class="form-control form-control-sm" value="{{ regulation.id }}"
                      readonly />
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="form-group">
                  <div class="left inline label-heading control-label mb-1 fw">
                    Geography
                  </div>
                  <div class="input-group">
                    <input type="text" id="SerachText" class="form-control form-control-sm"
                      value="{{ regulation.geography }}" readonly />
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="form-group">
                  <div class="left inline label-heading control-label mb-1 fw">
                    Country
                  </div>
                  <input type="text" id="SerachText" class="form-control form-control-sm"
                    value="{{ regulation.country }}" readonly />
                </div>
              </div>
              <div class="col-lg-2">
                <div class="left inline label-heading control-label mb-1 fw">
                  Regulator
                </div>
                <input type="text" class="small-text-gray form-control form-control-sm"
                  value="{{ regulation.regulator }}" readonly />
              </div>
              <div class="col-lg-2">
                <div class="form-group">
                  <div class="left inline label-heading control-label mb-1 fw">
                    Date
                  </div>
                  <div class="input-group input-group-sm">
                    <input class="form-control form-control-sm" value="{{ regulation.date }}" readonly />
                  </div>
                </div>
              </div>
              <div class="col-lg-8">
                <div class="form-group">
                  <div class="left inline label-heading control-label mb-1 fw">
                    Title
                  </div>
                  <div class="input-group div-scroll">
                    {{ regulation.title }}
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="form-group">
                  <div class="left inline label-heading control-label mb-1 fw">
                    Type
                  </div>
                  <div class="input-group div-scroll">
                    {{ regulation.pubType }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card">
          <div class="card-header card_actions text-header inc-f">
            Actions 
          </div>
          <div class="card-body cards-height" *ngIf="isActionShow">
            <div class="row" *ngIf=" !currentRegulationDetails.isAssessed && !currentRegulationDetails.isClosed">
              <div class="col-md-12 mb-1" *ngIf="commonService.checkPlanTypeAction('CDSIA') && detailType <= 1">
                <a (click)="openPopUp(regulation.id)">
                  Start Impact Assessment 
                  <i *ngIf="isRegMovedToIA" class="fa fa-circle-o-notch fa-spin"
                    style="font-size: 0.875rem; line-height: 1.5"></i>
                </a>
              </div>
              <div class="col-md-12 mb-1 text-muted" *ngIf="detailType === 3">
                Start Impact Assessment 
              </div>
              <div class="col-md-12 mb-1 text-muted">Move to Library</div>
              <div class="col-md-12 mb-1" *ngIf="commonService.checkPlanTypeAction('CDC')">
                <a (click)="openDialog()">Close</a>
              </div>
            </div>
            <div class="row"
            *ngIf="currentRegulationDetails.isClosed">
            <!-- <div class="row"
              *ngIf="regulation.regulationDetails && regulation.regulationDetails.id > 0 && !regulation.impactAssessmentStatus"> -->
              <div class="col-md-12 mb-1" *ngIf="!currentRegulationDetails.isAssessed">
                <a (click)="openPopUp(regulation.id)">
                  Start Impact Assessment 
                  <i *ngIf="isRegMovedToIA" class="fa fa-circle-o-notch fa-spin"
                    style="font-size: 0.875rem; line-height: 1.5"></i>
                </a>
              </div>
              <div class="col-md-12 mb-1 text-muted">Move to Library</div>
              <div class="col-md-12 mb-1" *ngIf="commonService.checkPlanTypeAction('CDC')">
                <span *ngIf="commonService.checkPlanTypeAction('CDE')">
                  <span
                    *ngIf="checkEditPermission(regulation.closedRegulationUsers, regulation.jurisdiction) && currentRegulationDetails.isClosed">
                    <a (click)="openDialog()">Edit</a>
                  </span>
                  <span
                    *ngIf="!checkEditPermission(regulation.closedRegulationUsers, regulation.jurisdiction) && !currentRegulationDetails.isClosed">
                    <span class="text-muted cursor-default">Edit</span>
                  </span>
                </span>
              </div>
            </div>
            <div class="row" *ngIf="currentRegulationDetails.isAssessed">
              <div class="col-md-12 mb-1 text-muted">Move to Library</div>
              <div class="col-md-12 mb-1">
                <span *ngIf="commonService.checkPlanTypeAction('CDE')">
                  <span
                    *ngIf="checkEditPermission(regulation.closedRegulationUsers, regulation.jurisdiction) && currentRegulationDetails.isClosed">
                    <a (click)="openDialog()">Edit</a>
                  </span>
                  <span
                    *ngIf="!checkEditPermission(regulation.closedRegulationUsers, regulation.jurisdiction) && !currentRegulationDetails.isClosed">
                    <span class="text-muted cursor-default">Edit</span>
                  </span>
                </span>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col">
                <a class="float-left" href="{{ regulation.hyperlink }}" target="_blank"
                  [ngClass]="regulation.hyperlink ? '' : 'disabled'">
                  Source Link
                </a>
              </div>
              <div class="col">
                <div class="row" *ngIf="!isExpendedIconShow">
                  <div class="mb-2 text-muted"
                    *ngIf="regulationData.filterType === 'All' ? checkSibling(regulation.id, 'Next') :  checkSimilarSibling(regulation.id, 'Next')">
                    <span class="text-blue float-right"
                      (click)="regulationData.filterType === 'All' ? getSiblings('Next') : getSimilarSiblings('Next')">Next</span>
                  </div>
                </div>
                <div class="row" *ngIf="!isExpendedIconShow">
                  <div class="mb-2 text-muted"
                    *ngIf="regulationData.filterType === 'All' ? checkSibling(regulation.id, 'Previous') : checkSimilarSibling(regulation.id, 'Previous')">
                    <span class="text-blue float-right"
                      (click)="regulationData.filterType === 'All' ? getSiblings('Previous') : getSimilarSiblings('Previous')">Previous</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 2nd row -->
    <div class="row mt-3 middle-scroll">
      <!-- Linked updates & desc -->
      <div class="col col-md-9">
        <!-- linked updates -->
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <div class="desc-body mt-1">
                <span *ngIf="regulation.clientTopics">
                  <ng-container *ngFor="let clientTopicItemColor of regulation.clientTopics|jsonStringToArray">
                    <span *ngFor="let clientTopicItemName of sortArray(clientTopicItemColor[1])"
                      class="highlight-text-dinamically rp-highlight item-text"
                      [style.background-color]=" clientTopicItemColor[0]"
                      [style.color]="getContrastYIQ( clientTopicItemColor[0])">
                      <span class="font-weight-normal"
                        (click)="searchRuleTopic(clientTopicItemName)">{{clientTopicItemName}}</span>
                    </span>
                  </ng-container>
                </span>
                <ng-container *ngIf="regulation.ruleTopic && !regulation.staticLibraryRuleTopic">
                  <div *ngFor="let rt of sortArray(regulation.ruleTopic.split(','))"
                    class="highlight-text-blue rp-highlight ruleBorder">
                    {{rt}}
                  </div>
                </ng-container>
                <ng-container *ngIf="regulation.nlpRuleTopic && !regulation.staticLibraryRuleTopic">
                  <div *ngFor="let nlprt of sortArray(regulation.nlpRuleTopic.split(','))"
                    class="highlight-text-gray rp-highlight ruleBorder">
                    {{nlprt}}
                  </div>
                </ng-container>
                <ng-container *ngIf="regulation.staticLibraryRuleTopic">
                  <div *ngFor="let nlprt of sortArray(regulation.staticLibraryRuleTopic.split(','))"
                    class="highlight-text-gray rp-highlight ruleBorder">
                    {{nlprt}}
                  </div>
                </ng-container>
                <div class="mt-2" *ngIf="regulation.similarityIndex">
                  <div>Linked Updates: </div>
                  <div *ngFor="let sindex of getElementsByFilter(regulation.similarityIndex.split('||'), '')"
                    class="highlight-text-gray  rp-highlight ruleBorder">
                    <span *ngIf="regulationData.filterType"
                      (click)="showComparison(sindex.split('|')[0])">{{sindex}}</span>
                    <span *ngIf="!regulationData.filterType">{{sindex}}</span>
                  </div>
                  <div *ngIf="regulation.similarityIndex.split('||').length > 5 && !showMoreLessResult(regulation.id)"
                    class="highlight-text-gray  rp-highlight ruleBorder">
                    <span (click)="showHideSimilarity(regulation.id)">Show More</span>
                  </div>
                  <ng-container *ngIf="showMoreLessResult(regulation.id)">
                    <div *ngFor="let sindex of getElementsByFilter(regulation.similarityIndex.split('||'), 'All')"
                      class="highlight-text-gray  rp-highlight ruleBorder">
                      <span *ngIf="regulationData.filterType"
                        (click)="showComparison(sindex.split('|')[0])">{{sindex}}</span>
                      <span *ngIf="!regulationData.filterType">{{sindex}}</span>
                    </div>
                    <div class="highlight-text-gray  rp-highlight ruleBorder">
                      <span (click)="showHideSimilarity(regulation.id)">Show Less</span>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- desc -->
        <div class="row">
          <div class="col-12">
            <div class="form-group desc-text-box">
              <div class="d-flex justify-content-between col-12 col-md-12">
                <div class="left inline label-heading control-label mb-1 fw">
                  Description
                </div>
                <div class="text-right description_buttons2">
                  <span class="translate_spinner text-blue" *ngIf="!isShowDescriptionEditor"><button
                      class="icon_btn"><lucide-icon name="languages" (click)="translateDescription()"
                        matTooltip="Translate" class="text-blue-lucide"></lucide-icon></button>
                    <svg class="svg" *ngIf="isAssessmentLoader" id="Layer_1" enable-background="new 0 0 24 24" height="512"
                      viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="m18.4 5.6-1.4 1.5c-2.7-2.7-7.2-2.7-9.9 0s-2.7 7.2 0 9.9 7.2 2.7 9.9 0c1.3-1.3 2.1-3.1 2.1-4.9h2c0 5-4 9-9 9s-9-4-9-9 4-9 9-9c2.3-.1 4.6.8 6.3 2.5z" />
                    </svg>
                  </span>
                </div>
              </div>
              <div class="edit_status_changeViewer_group text-area-css"
                *ngIf="regulation.description && regulation.description.indexOf('<div') < 0 && !isShowDescriptionEditor">
                <div class="disableText w-100">
                  <!-- <textarea matInput [(ngModel)]="regulation.description" class="text-area-css" cdkTextareaAutosize
                    disabled [innerHTML]="regulation.description"></textarea> -->
                  <div *ngIf="regulation.description | hasHtmlTags; else noHtmlTags"
                    [innerHTML]="regulation.description"></div>
                </div>
                <ng-template #noHtmlTags>
                  <mat-form-field class="disableText w-100">
                    <textarea matInput cdkTextareaAutosize disabled class="text-area-css textarea_input">
                         {{regulation.description}}
                        </textarea>
                  </mat-form-field>
                </ng-template>
              </div>
              <div class="col-lg-12 desc-text-box"
                *ngIf="regulation.description && regulation.description.indexOf('<div') >= 0  && !isShowDescriptionEditor">
                <div *ngIf="regulation.description | hasHtmlTags; else noHtmlTags" [innerHTML]="regulation.description">
                </div>
                <!-- <div [innerHtml]="regulation.description"></div> -->
              </div>
              <app-ck-editor class="translate_editor" [(childVariable)]="descriptionInEditor" id="description"
                *ngIf="isShowDescriptionEditor" [data]="descriptionInEditor"></app-ck-editor>
            </div>
          </div>
        </div>
      </div>
      <!-- status & regulation tree -->
      <div class="col col-md-3">
        <!-- status -->
        <div class="row">
          <div class="col-12">
            <app-current-action-card [userId]="userProfile.userId" [itemId]="currentRegulationId" [closedType]=""
              [regulationDetails]="regulation" [currentActions]="" (OnFilter)="isCurrentAction($event)">
            </app-current-action-card>
          </div>
        </div>
        <!-- regulation tree -->
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header text-header inc-f">
                Impact of Regulation
                <span class="float-right text-blue fa mt-1" role="button" *ngIf="isExpendedIconShow"
                  [attr.title]="isRegChartExpanded ? 'Minimize' : 'Maximize'"
                  [ngClass]="isRegChartExpanded ? 'fa-compress' : 'fa-expand'" (click)="expandPanel()"></span>
              </div>
              <div class="card-body impact-regulation-tree">
                <div *ngIf="dataSource.data.length>0">
                  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
                    <!-- This is the tree node template for leaf nodes -->
                    <mat-tree-node class="impact-regulation-tree" *matTreeNodeDef="let node" matTreeNodeToggle>
                      <li class="mat-tree-node">
                        <!-- use a disabled button to provide padding for tree leaf -->
                        <button mat-icon-button disabled></button>
                        <span> {{node.realname}} </span>
                      </li>
                    </mat-tree-node>
                    <!-- This is the tree node template for expandable nodes -->
                    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                      <li>
                        <div class="mat-tree-node">
                          <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.realname">
                            <mat-icon class="mat-icon-rtl-mirror">
                              {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                            </mat-icon>
                          </button>
                          <span> {{node.realname}} </span>
                        </div>
                        <ul [class.example-tree-invisible]="!treeControl.isExpanded(node)">
                          <ng-container matTreeNodeOutlet></ng-container>
                        </ul>
                      </li>
                    </mat-nested-tree-node>
                  </mat-tree>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Impact of regulation d3 -->
    <div class="row">
      <div class="col-12">
        <div class="card mt-4 mb-2" [ngClass]="isRegChartExpanded ? 'card-expanded' : ''" *ngIf="detailType <= 1"
          id="tabView">
          <div class="card-header text-header inc-f">
            Impact of Regulation
            <span class="float-right text-blue fa mt-1" role="button" *ngIf="isExpendedIconShow"
              [attr.title]="isRegChartExpanded ? 'Minimize' : 'Maximize'"
              [ngClass]="isRegChartExpanded ? 'fa-compress' : 'fa-expand'" (click)="expandPanel()"></span>
          </div>
          <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
          <div class="card-body card-body-p">
            <iframe *ngIf="showChartCont" class="height-600 iframe" (load)="isLoading = false"
              [class.d-none]="isLoading" [src]="iframeSRC" style="width: 100%"></iframe>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- comparision -->
  <div class="col-lg-6 pl-4" *ngIf="isShowComparison && secondRegulation">
    <app-toast [toastModel]="toastViewModel" *ngIf="isShowToast"></app-toast>
    <div class="row">
      <div class="col-md-12">
        <!-- Details -->
        <div class="card">
          <div class="card-header text-header inc-f">
            Details
            <button class="fa fa-times pull-right" (click)="isShowComparison = false"
              style="cursor: pointer;background: none;border:none" aria-hidden="true"></button>
          </div>
          <div class="card-body card-height">
            <div class="row">
              <div class="col-lg-2">
                <div class="form-group">
                  <div class="left inline label-heading control-label mb-1 fw">
                    Change ID
                  </div>
                  <div class="input-group">
                    <input type="text" id="SerachText" class="form-control form-control-sm"
                      value="{{ secondRegulation.id }}" readonly />
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="form-group">
                  <div class="left inline label-heading control-label mb-1 fw">
                    Geography
                  </div>
                  <div class="input-group">
                    <input type="text" id="SerachText" class="form-control form-control-sm"
                      value="{{ secondRegulation.geography }}" readonly />
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="form-group">
                  <div class="left inline label-heading control-label mb-1 fw">
                    Country
                  </div>
                  <input type="text" id="SerachText" class="form-control form-control-sm"
                    value="{{ secondRegulation.country }}" readonly />
                </div>
              </div>
              <div class="col-lg-2">
                <div class="left inline label-heading control-label mb-1 fw">
                  Regulator
                </div>
                <input type="text" class="small-text-gray form-control form-control-sm"
                  value="{{ secondRegulation.regulator }}" readonly />
              </div>
              <div class="col-lg-2">
                <div class="form-group">
                  <div class="left inline label-heading control-label mb-1 fw">
                    Date
                  </div>
                  <div class="input-group input-group-sm">
                    <input class="form-control form-control-sm" value="{{ secondRegulation.date }}" readonly />
                  </div>
                </div>
              </div>
              <div class="col-lg-8">
                <div class="form-group">
                  <div class="left inline label-heading control-label mb-1 fw">
                    Title
                  </div>
                  <div class="input-group div-scroll">
                    {{ secondRegulation.title }}
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="form-group">
                  <div class="left inline label-heading control-label mb-1 fw">
                    Type
                  </div>
                  <div class="input-group div-scroll">
                    {{ secondRegulation.pubType }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 2nd row -->
        <div class="row mt-3 middle-scroll">
          <!-- Linked updates & desc -->
          <div class="col col-md-9">
            <!-- linked updates -->
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <div class="desc-body mt-1">
                    <ng-container *ngIf="secondRegulation.ruleTopic && !secondRegulation.staticLibraryRuleTopic">
                      <div *ngFor="let rt of sortArray(secondRegulation.ruleTopic.split(','))"
                        class="highlight-text-blue rp-highlight">
                        {{rt}}
                      </div>
                    </ng-container>
                    <ng-container *ngIf="secondRegulation.nlpRuleTopic && !secondRegulation.staticLibraryRuleTopic">
                      <div *ngFor="let nlprt of sortArray(secondRegulation.nlpRuleTopic.split(','))"
                        class="highlight-text-gray rp-highlight">
                        {{nlprt}}
                      </div>
                    </ng-container>
                    <ng-container *ngIf="secondRegulation.staticLibraryRuleTopic">
                      <div *ngFor="let nlprt of sortArray(secondRegulation.staticLibraryRuleTopic.split(','))"
                        class="highlight-text-gray rp-highlight">
                        {{nlprt}}
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
            <!-- desc -->
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <div class="row">
                    <div class="col-4 col-md-8">
                      <div class="left inline label-heading control-label mb-1 fw">
                        Description
                      </div>
                    </div>
                    <div class="col-8 col-md-4 text-right">
                    </div>
                  </div>
                  <div class="disableText">
                    <!-- <textarea matInput class="text-area-css" cdkTextareaAutosize disabled> -->
                    {{ secondRegulation.description }}
                    <!-- </textarea> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- status & regulation tree -->
          <div class="col col-md-3">
            <!-- status -->
            <div class="row">
              <div class="col-12">
                <app-current-action-card [userId]="userProfile.userId" [itemId]="compareRegulationId" [closedType]=""
                  [regulationDetails]="secondRegulation" [currentActions]="" (OnFilter)="isCurrentAction($event)">
                </app-current-action-card>
              </div>
            </div>
            <!-- regulation tree -->
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-header text-header inc-f">
                    Impact of Regulation
                    <span class="float-right text-blue fa mt-1" role="button" *ngIf="isExpendedIconShow"
                      [attr.title]="isRegChartExpanded ? 'Minimize' : 'Maximize'"
                      [ngClass]="isRegChartExpanded ? 'fa-compress' : 'fa-expand'" (click)="expandPanel()"></span>
                  </div>
                  <div class="card-body impact-regulation-tree">
                    <div *ngIf="dataSourceComp.data.length>0">
                      <mat-tree [dataSource]="dataSourceComp" [treeControl]="treeControlComp" class="example-tree">
                        <!-- This is the tree node template for leaf nodes -->
                        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                          <li class="mat-tree-node">
                            <!-- use a disabled button to provide padding for tree leaf -->
                            <button mat-icon-button disabled></button>
                            <span> {{node.realname}} </span>
                          </li>
                        </mat-tree-node>
                        <!-- This is the tree node template for expandable nodes -->
                        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                          <li>
                            <div class="mat-tree-node">
                              <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.realname">
                                <mat-icon class="mat-icon-rtl-mirror">
                                  {{treeControlComp.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                                </mat-icon>
                              </button>
                              <span> {{node.realname}} </span>
                            </div>
                            <ul [class.example-tree-invisible]="!treeControlComp.isExpanded(node)">
                              <ng-container matTreeNodeOutlet></ng-container>
                            </ul>
                          </li>
                        </mat-nested-tree-node>
                      </mat-tree>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- impqct of regulation d3 -->
        <div class="row">
          <div class="col-12">
            <div class="card mt-4 mb-2" [ngClass]="isRegChartExpanded ? 'card-expanded' : ''" *ngIf="detailType <= 1"
              id="tabView">
              <div class="card-header text-header inc-f">
                Impact of Regulation
                <span class="float-right text-blue fa mt-1" role="button" *ngIf="isExpendedIconShow"
                  [attr.title]="isRegChartExpanded ? 'Minimize' : 'Maximize'"
                  [ngClass]="isRegChartExpanded ? 'fa-compress' : 'fa-expand'" (click)="expandPanel()"></span>
              </div>
              <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
              <div class="card-body card-body-p">
                <iframe *ngIf="showChartCont" class="height-600 iframe" (load)="isLoading = false"
                  [class.d-none]="isLoading" [src]="iframeSRC2" style="width: 100%"></iframe>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
<div *ngIf="isRigMap">
  <div>
    <app-change-viewer-rig [regulation]="regulation" [updatedDbId]="currentRegulationId" [userJurisdiction]="userJurisdiction"
    [user]="userProfile"></app-change-viewer-rig>
  </div>
</div>

<!--Regulatory Insights Generator-->
<div *ngIf="isRig">
  <div>
    <app-change-viewer-regulatory [regulation]="regulation" [updatedDbId]="currentRegulationId" [userJurisdiction]="userJurisdiction"
    [user]="userProfile"></app-change-viewer-regulatory>
  </div>
</div>



<!-- OLD LAYOUT -->

<!-- <div class="row">
  <div [ngClass]="!isShowComparison ? 'col-lg-12' : 'col-lg-6 pr-0'">
    <app-toast [toastModel]="toastViewModel" *ngIf="isShowToast"></app-toast>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-9 pr-0">
              <div class="card">
                <div class="card-header text-header inc-f">
                  <span class="fa fa-list"></span> Details
                </div>
                <div class="card-body card-height">
                  <div class="row">
                    <div class="col-lg-2">
                      <div class="form-group">
                        <div class="left inline label-heading control-label mb-1 fw">
                          Change ID
                        </div>
                        <div class="input-group">
                          <input type="text" id="SerachText" class="form-control form-control-sm"
                            value="{{ regulation.id }}" readonly />
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-3">
                      <div class="form-group">
                        <div class="left inline label-heading control-label mb-1 fw">
                          Geography
                        </div>
                        <div class="input-group">
                          <input type="text" id="SerachText" class="form-control form-control-sm"
                            value="{{ regulation.geography }}" readonly />
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-3">
                      <div class="form-group">
                        <div class="left inline label-heading control-label mb-1 fw">
                          Country
                        </div>
                        <input type="text" id="SerachText" class="form-control form-control-sm"
                          value="{{ regulation.country }}" readonly />
                      </div>
                    </div>
                    <div class="col-lg-2">
                      <div class="left inline label-heading control-label mb-1 fw">
                        Regulator
                      </div>
                      <input type="text" class="small-text-gray form-control form-control-sm"
                        value="{{ regulation.regulator }}" readonly />
                    </div>
                    <div class="col-lg-2">
                      <div class="form-group">
                        <div class="left inline label-heading control-label mb-1 fw">
                          Date
                        </div>
                        <div class="input-group input-group-sm">
                          <input class="form-control form-control-sm" value="{{ regulation.date }}" readonly />
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-8">
                      <div class="form-group">
                        <div class="left inline label-heading control-label mb-1 fw">
                          Title
                        </div>
                        <div class="input-group div-scroll">
                          {{ regulation.title }}
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4">
                      <div class="form-group">
                        <div class="left inline label-heading control-label mb-1 fw">
                          Type
                        </div>
                        <div class="input-group div-scroll">
                          {{ regulation.pubType }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="card">
                <div class="card-header text-header inc-f">
                  <span class="fa fa-list"></span> Actions
                </div>
                <div class="card-body card-height">
                  <div class="row" *ngIf=" !regulation.regulationDetails && !regulation.impactAssessmentStatus">
                    <div class="col-md-12 mb-1" *ngIf="commonService.checkPlanTypeAction('CDSIA') && detailType <= 1">
                      <a (click)="openPopUp(regulation.id)">
                        Start Impact Assessment
                        <i *ngIf="isRegMovedToIA" class="fa fa-circle-o-notch fa-spin"
                          style="font-size: 0.875rem; line-height: 1.5"></i>
                      </a>
                    </div>
                    <div class="col-md-12 mb-1 text-muted" *ngIf="detailType === 3">
                      Start Impact Assessment
                    </div>
                    <div class="col-md-12 mb-1 text-muted">Start Self Assessment</div>
                    <div class="col-md-12 mb-1 text-muted">Move to Library</div>
                    <div class="col-md-12 mb-1" *ngIf="commonService.checkPlanTypeAction('CDC')">
                      <a (click)="openDialog()">Close</a>
                    </div>
                  </div>
                  <div class="row"
                    *ngIf="regulation.regulationDetails && regulation.regulationDetails.id > 0 && !regulation.impactAssessmentStatus">
                    <div class="col-md-12 mb-1 text-muted">
                      Start Impact Assessment
                    </div>
                    <div class="col-md-12 mb-1 text-muted">Start Self Assessment</div>
                    <div class="col-md-12 mb-1 text-muted">Move to Library</div>
                    <div class="col-md-12 mb-1">
                      <span *ngIf="commonService.checkPlanTypeAction('CDE')">
                        <span *ngIf="checkEditPermission(regulation.closedRegulationUsers, regulation.jurisdiction)">
                          <a (click)="openDialog()">Edit</a>
                        </span>
                        <span *ngIf="!checkEditPermission(regulation.closedRegulationUsers, regulation.jurisdiction)">
                          <span class="text-muted cursor-default">Edit</span>
                        </span>
                      </span>
                    </div>
                  </div>
                  <div class="row" *ngIf="regulation.impactAssessmentStatus">
                    <div class="col-md-12 mb-1 text-muted">
                      Start Impact Assessment
                    </div>
                    <div class="col-md-12 mb-1 text-muted">Start Self Assessment</div>
                    <div class="col-md-12 mb-1 text-muted">Move to Library</div>
                    <div class="col-md-12 mb-1 text-muted">Edit</div>
                  </div>
                  <div class="row" *ngIf="!isExpendedIconShow">
                    <div class="col-md-12 mb-1 text-muted mt-3"
                      *ngIf="regulationData.filterType === 'All' ? checkSibling(regulation.id, 'Next') :  checkSimilarSibling(regulation.id, 'Next')">
                      <span class="text-blue"
                        (click)="regulationData.filterType === 'All' ? getSiblings('Next') : getSimilarSiblings('Next')">Next</span>
                    </div>
                    <div class="col-md-12 text-muted"
                      *ngIf="regulationData.filterType === 'All' ? checkSibling(regulation.id, 'Previous') : checkSimilarSibling(regulation.id, 'Previous')">
                      <span class="text-blue"
                        (click)="regulationData.filterType === 'All' ? getSiblings('Previous') : getSimilarSiblings('Previous')">Previous</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body pb-0">
            <div class="row">
              <div class="col-lg-9">
                <div class="form-group">
                  <div class="desc-body mt-1">
                    <span *ngIf="regulation.clientTopics">
                      <ng-container *ngFor="let clientTopicItemColor of regulation.clientTopics|jsonStringToArray">
                        <span *ngFor="let clientTopicItemName of sortArray(clientTopicItemColor[1])"
                          class="highlight-text-dinamically rp-highlight item-text"
                          [style.background-color]=" clientTopicItemColor[0]"
                          [style.color]="getContrastYIQ( clientTopicItemColor[0])">
                          <span class="font-weight-normal"
                            (click)="searchRuleTopic(clientTopicItemName)">{{clientTopicItemName}}</span>
                        </span>
                      </ng-container>
                    </span>
                    <ng-container *ngIf="regulation.ruleTopic && !regulation.staticLibraryRuleTopic">
                      <div *ngFor="let rt of sortArray(regulation.ruleTopic.split(','))"
                        class="highlight-text-blue rp-highlight ruleBorder">
                        {{rt}}
                      </div>
                    </ng-container>
                    <ng-container *ngIf="regulation.nlpRuleTopic && !regulation.staticLibraryRuleTopic">
                      <div *ngFor="let nlprt of sortArray(regulation.nlpRuleTopic.split(','))"
                        class="highlight-text-gray rp-highlight ruleBorder">
                        {{nlprt}}
                      </div>
                    </ng-container>
                    <ng-container *ngIf="regulation.staticLibraryRuleTopic">
                      <div *ngFor="let nlprt of sortArray(regulation.staticLibraryRuleTopic.split(','))"
                        class="highlight-text-gray rp-highlight ruleBorder">
                        {{nlprt}}
                      </div>
                    </ng-container>
                    <div class="mt-2" *ngIf="regulation.similarityIndex">
                      <div>Linked Updates: </div>
                      <div *ngFor="let sindex of getElementsByFilter(regulation.similarityIndex.split('||'), '')"
                        class="highlight-text-gray  rp-highlight ruleBorder">
                        <span *ngIf="regulationData.filterType"
                          (click)="showComparison(sindex.split('|')[0])">{{sindex}}</span>
                        <span *ngIf="!regulationData.filterType">{{sindex}}</span>
                      </div>
                      <div
                        *ngIf="regulation.similarityIndex.split('||').length > 5 && !showMoreLessResult(regulation.id)"
                        class="highlight-text-gray  rp-highlight ruleBorder">
                        <span (click)="showHideSimilarity(regulation.id)">Show More</span>
                      </div>
                      <ng-container *ngIf="showMoreLessResult(regulation.id)">
                        <div *ngFor="let sindex of getElementsByFilter(regulation.similarityIndex.split('||'), 'All')"
                          class="highlight-text-gray  rp-highlight ruleBorder">
                          <span *ngIf="regulationData.filterType"
                            (click)="showComparison(sindex.split('|')[0])">{{sindex}}</span>
                          <span *ngIf="!regulationData.filterType">{{sindex}}</span>
                        </div>
                        <div class="highlight-text-gray  rp-highlight ruleBorder">
                          <span (click)="showHideSimilarity(regulation.id)">Show Less</span>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 side-border">
                <app-current-action [userId]="userProfile.userId" [itemId]="regulationData.id" [closedType]=""
                  [regulationDetails]="regulation" [currentActions]="" (OnFilter)="isCurrentAction($event)">
                </app-current-action>
              </div>
            </div>
            <div class="form-group desc-text-box">
              <div class="row">
                <div class="col-4 col-md-8">
                  <div class="left inline label-heading control-label mb-1 fw">
                    Description
                  </div>
                </div>
                <div class="col-8 col-md-4 text-right">
                  <a href="{{ regulation.hyperlink }}" target="_blank"
                    [ngClass]="regulation.hyperlink ? '' : 'disabled'">
                    <span class="fa fa-globe fw"></span>
                    View Website Link
                  </a>
                </div>
              </div>
              <mat-form-field class="disableText"
                *ngIf="regulation.description && regulation.description.indexOf('<div') < 0">
                <textarea matInput class="text-area-css" cdkTextareaAutosize disabled>
                {{ regulation.description }}
                </textarea>
              </mat-form-field>
              <div class="col-lg-12 desc-text-box"
                *ngIf="regulation.description && regulation.description.indexOf('<div') >= 0">
                <div [innerHtml]="regulation.description"></div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div class="card mt-4 mb-2" [ngClass]="isRegChartExpanded ? 'card-expanded' : ''" *ngIf="detailType <= 1"
          id="tabView">
          <div class="card-header text-header inc-f">
            <span class="fa fa-list"></span> Impact of Regulation
            <span class="float-right text-blue fa mt-1" role="button" *ngIf="isExpendedIconShow"
              [attr.title]="isRegChartExpanded ? 'Minimize' : 'Maximize'"
              [ngClass]="isRegChartExpanded ? 'fa-compress' : 'fa-expand'" (click)="expandPanel()"></span>
          </div>
          <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
          <div class="card-body card-body-p">
            <mat-tab-group (selectedTabChange)="tabChanged($event)">
              <mat-tab label="Linked Rules">
                <iframe *ngIf="showChartCont" class="height-600" (load)="isLoading = false" [class.d-none]="isLoading"
                  [src]="iframeSRC" style="width: 100%"></iframe>
              </mat-tab>
              <mat-tab label="Rule Analytics">
                <h2 class="p-2">Comming soon....</h2>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-6" *ngIf="isShowComparison">
    <app-toast [toastModel]="toastViewModel" *ngIf="isShowToast"></app-toast>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header text-header inc-f">
            <span class="fa fa-list"></span> Details
            <button class="fa fa-times pull-right" (click)="isShowComparison = false"
              style="cursor: pointer;background: none;border:none" aria-hidden="true"></button>
          </div>
          <div class="card-body card-height">
            <div class="row">
              <div class="col-lg-2">
                <div class="form-group">
                  <div class="left inline label-heading control-label mb-1 fw">
                    Change ID
                  </div>
                  <div class="input-group">
                    <input type="text" id="SerachText" class="form-control form-control-sm"
                      value="{{ secondRegulation.id }}" readonly />
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="form-group">
                  <div class="left inline label-heading control-label mb-1 fw">
                    Geography
                  </div>
                  <div class="input-group">
                    <input type="text" id="SerachText" class="form-control form-control-sm"
                      value="{{ secondRegulation.geography }}" readonly />
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="form-group">
                  <div class="left inline label-heading control-label mb-1 fw">
                    Country
                  </div>
                  <input type="text" id="SerachText" class="form-control form-control-sm"
                    value="{{ secondRegulation.country }}" readonly />
                </div>
              </div>
              <div class="col-lg-2">
                <div class="left inline label-heading control-label mb-1 fw">
                  Regulator
                </div>
                <input type="text" class="small-text-gray form-control form-control-sm"
                  value="{{ secondRegulation.regulator }}" readonly />
              </div>
              <div class="col-lg-2">
                <div class="form-group">
                  <div class="left inline label-heading control-label mb-1 fw">
                    Date
                  </div>
                  <div class="input-group input-group-sm">
                    <input class="form-control form-control-sm" value="{{ secondRegulation.date }}" readonly />
                  </div>
                </div>
              </div>
              <div class="col-lg-8">
                <div class="form-group">
                  <div class="left inline label-heading control-label mb-1 fw">
                    Title
                  </div>
                  <div class="input-group div-scroll">
                    {{ secondRegulation.title }}
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="form-group">
                  <div class="left inline label-heading control-label mb-1 fw">
                    Type
                  </div>
                  <div class="input-group div-scroll">
                    {{ secondRegulation.pubType }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body pb-0">
            <div class="form-group">
              <div class="desc-body mt-1">
                <ng-container *ngIf="secondRegulation.ruleTopic && !secondRegulation.staticLibraryRuleTopic">
                  <div *ngFor="let rt of sortArray(secondRegulation.ruleTopic.split(','))"
                    class="highlight-text-blue rp-highlight">
                    {{rt}}
                  </div>
                </ng-container>
                <ng-container *ngIf="secondRegulation.nlpRuleTopic && !secondRegulation.staticLibraryRuleTopic">
                  <div *ngFor="let nlprt of sortArray(secondRegulation.nlpRuleTopic.split(','))"
                    class="highlight-text-gray rp-highlight">
                    {{nlprt}}
                  </div>
                </ng-container>
                <ng-container *ngIf="secondRegulation.staticLibraryRuleTopic">
                  <div *ngFor="let nlprt of sortArray(secondRegulation.staticLibraryRuleTopic.split(','))"
                    class="highlight-text-gray rp-highlight">
                    {{nlprt}}
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-4 col-md-8">
                  <div class="left inline label-heading control-label mb-1 fw">
                    Description
                  </div>
                </div>
                <div class="col-8 col-md-4 text-right">
                  <a href="{{ secondRegulation.hyperlink }}" target="_blank"
                    [ngClass]="secondRegulation.hyperlink ? '' : 'disabled'">
                    <span class="fa fa-globe fw"></span>
                    View Website Link
                  </a>
                </div>
              </div>
              <mat-form-field class="disableText">
                <textarea matInput class="text-area-css" cdkTextareaAutosize disabled>
              {{ secondRegulation.description }}
            </textarea>
              </mat-form-field>
            </div>
          </div>
        </div>
        <hr />
        <div class="card mt-4 mb-2" [ngClass]="isRegChartExpanded ? 'card-expanded' : ''" *ngIf="detailType <= 1"
          id="tabView">
          <div class="card-header text-header inc-f">
            <span class="fa fa-list"></span> Impact of Regulation
            <span class="float-right text-blue fa mt-1" role="button" *ngIf="isExpendedIconShow"
              [attr.title]="isRegChartExpanded ? 'Minimize' : 'Maximize'"
              [ngClass]="isRegChartExpanded ? 'fa-compress' : 'fa-expand'" (click)="expandPanel()"></span>
          </div>
          <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
          <div class="card-body card-body-p">
            <mat-tab-group (selectedTabChange)="tabChanged($event)">
              <mat-tab label="Linked Rules">
                <iframe *ngIf="showChartCont" class="height-600" (load)="isLoading = false" [class.d-none]="isLoading"
                  [src]="iframeSRC2" style="width: 100%"></iframe>
              </mat-tab>
              <mat-tab label="Rule Analytics">
                <h2 class="p-2">Comming soon....</h2>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->
